export default "__VITE_ASSET__C1N_qIAY__"